// extracted by mini-css-extract-plugin
export default {"form":"EditAffiliateForm_form__3b6k4"};